var map = {
	"./add-photo.png": 5781,
	"./add.png": 9878,
	"./addHover.png": 1739,
	"./addToSla-hover.png": 8071,
	"./addToSla.png": 8299,
	"./alert.png": 2713,
	"./arrow-left-3.png": 8490,
	"./arrow-right-3.png": 2472,
	"./bg-1.png": 8793,
	"./bg3.webp": 1618,
	"./cancel.png": 7160,
	"./chat.png": 652,
	"./close.png": 1460,
	"./company-group.png": 7585,
	"./company.png": 993,
	"./confirm.png": 2569,
	"./copy-2.png": 727,
	"./copy-3.png": 5881,
	"./copy.png": 8901,
	"./copyHover.png": 1086,
	"./cordlynx.png": 982,
	"./defacto-logo.svg": 3690,
	"./delete.png": 1125,
	"./done.png": 3013,
	"./down-arrow.png": 4897,
	"./edit.png": 8975,
	"./email.png": 3005,
	"./engine.png": 5806,
	"./error.png": 5551,
	"./ex.png": 6394,
	"./ex1.png": 9103,
	"./ex2.png": 8470,
	"./export.png": 3958,
	"./eye.png": 2468,
	"./flags/ad.png": 8435,
	"./flags/ae.png": 7475,
	"./flags/af.png": 5069,
	"./flags/ag.png": 7947,
	"./flags/ai.png": 3219,
	"./flags/al.png": 140,
	"./flags/am.png": 6615,
	"./flags/ao.png": 8355,
	"./flags/aq.png": 1729,
	"./flags/ar.png": 3341,
	"./flags/as.png": 7880,
	"./flags/at.png": 5156,
	"./flags/au.png": 4682,
	"./flags/aw.png": 5886,
	"./flags/ax.png": 4408,
	"./flags/az.png": 3177,
	"./flags/ba.png": 3830,
	"./flags/bb.png": 4446,
	"./flags/bd.png": 6833,
	"./flags/be.png": 1985,
	"./flags/bf.png": 7004,
	"./flags/bg.png": 1369,
	"./flags/bh.png": 9259,
	"./flags/bi.png": 8367,
	"./flags/bj.png": 577,
	"./flags/bl.png": 9498,
	"./flags/bm.png": 9530,
	"./flags/bn.png": 2659,
	"./flags/bo.png": 9264,
	"./flags/bq.png": 4240,
	"./flags/br.png": 1024,
	"./flags/bs.png": 5098,
	"./flags/bt.png": 4772,
	"./flags/bv.png": 7291,
	"./flags/bw.png": 918,
	"./flags/by.png": 7960,
	"./flags/bz.png": 4,
	"./flags/ca.png": 8734,
	"./flags/cc.png": 1828,
	"./flags/cd.png": 7364,
	"./flags/cf.png": 9629,
	"./flags/cg.png": 8661,
	"./flags/ch.png": 7900,
	"./flags/ci.png": 6299,
	"./flags/ck.png": 8181,
	"./flags/cl.png": 1983,
	"./flags/cm.png": 1174,
	"./flags/cn.png": 8950,
	"./flags/co.png": 412,
	"./flags/cr.png": 891,
	"./flags/cu.png": 4285,
	"./flags/cv.png": 5188,
	"./flags/cw.png": 867,
	"./flags/cx.png": 8774,
	"./flags/cy.png": 778,
	"./flags/cz.png": 1906,
	"./flags/de.png": 2553,
	"./flags/dj.png": 7847,
	"./flags/dk.png": 1601,
	"./flags/dm.png": 7610,
	"./flags/do.png": 8068,
	"./flags/dz.png": 9524,
	"./flags/ec.png": 6218,
	"./flags/ee.png": 7653,
	"./flags/eg.png": 8171,
	"./flags/eh.png": 2475,
	"./flags/er.png": 629,
	"./flags/es.png": 4894,
	"./flags/et.png": 2175,
	"./flags/fi.png": 8771,
	"./flags/fj.png": 4450,
	"./flags/fk.png": 933,
	"./flags/fm.png": 5900,
	"./flags/fo.png": 7089,
	"./flags/fr.png": 9871,
	"./flags/ga.png": 6655,
	"./flags/gb-eng.png": 7211,
	"./flags/gb-nir.png": 1057,
	"./flags/gb-sct.png": 5014,
	"./flags/gb-wls.png": 1365,
	"./flags/gb.png": 8531,
	"./flags/gd.png": 3323,
	"./flags/ge.png": 5581,
	"./flags/gf.png": 4043,
	"./flags/gg.png": 4851,
	"./flags/gh.png": 761,
	"./flags/gi.png": 255,
	"./flags/gl.png": 7553,
	"./flags/gm.png": 112,
	"./flags/gn.png": 5483,
	"./flags/gp.png": 1205,
	"./flags/gq.png": 2373,
	"./flags/gr.png": 6225,
	"./flags/gs.png": 57,
	"./flags/gt.png": 4636,
	"./flags/gu.png": 2674,
	"./flags/gw.png": 3128,
	"./flags/gy.png": 2559,
	"./flags/hk.png": 8096,
	"./flags/hm.png": 9507,
	"./flags/hn.png": 8750,
	"./flags/hr.png": 8088,
	"./flags/ht.png": 8621,
	"./flags/hu.png": 8835,
	"./flags/id.png": 6839,
	"./flags/ie.png": 6215,
	"./flags/il.png": 2864,
	"./flags/im.png": 2118,
	"./flags/in.png": 5878,
	"./flags/io.png": 5232,
	"./flags/iq.png": 6316,
	"./flags/ir.png": 2990,
	"./flags/is.png": 1210,
	"./flags/it.png": 1590,
	"./flags/je.png": 5745,
	"./flags/jm.png": 3945,
	"./flags/jo.png": 6881,
	"./flags/jp.png": 7385,
	"./flags/ke.png": 4544,
	"./flags/kg.png": 5888,
	"./flags/kh.png": 5847,
	"./flags/ki.png": 8219,
	"./flags/km.png": 3409,
	"./flags/kn.png": 8356,
	"./flags/kp.png": 7779,
	"./flags/kr.png": 4626,
	"./flags/kw.png": 1545,
	"./flags/ky.png": 4081,
	"./flags/kz.png": 3949,
	"./flags/la.png": 4345,
	"./flags/lb.png": 9470,
	"./flags/lc.png": 5774,
	"./flags/li.png": 2381,
	"./flags/lk.png": 3763,
	"./flags/lr.png": 9721,
	"./flags/ls.png": 3280,
	"./flags/lt.png": 6474,
	"./flags/lu.png": 8376,
	"./flags/lv.png": 7117,
	"./flags/ly.png": 5579,
	"./flags/ma.png": 6405,
	"./flags/mc.png": 2617,
	"./flags/md.png": 6385,
	"./flags/me.png": 9907,
	"./flags/mf.png": 5489,
	"./flags/mg.png": 3024,
	"./flags/mh.png": 6048,
	"./flags/mk.png": 5269,
	"./flags/ml.png": 8241,
	"./flags/mm.png": 6132,
	"./flags/mn.png": 2602,
	"./flags/mo.png": 3644,
	"./flags/mp.png": 2494,
	"./flags/mq.png": 9393,
	"./flags/mr.png": 6961,
	"./flags/ms.png": 724,
	"./flags/mt.png": 7179,
	"./flags/mu.png": 8529,
	"./flags/mv.png": 510,
	"./flags/mw.png": 8050,
	"./flags/mx.png": 1151,
	"./flags/my.png": 1805,
	"./flags/mz.png": 5864,
	"./flags/na.png": 3283,
	"./flags/nc.png": 7687,
	"./flags/ne.png": 6461,
	"./flags/nf.png": 4153,
	"./flags/ng.png": 4352,
	"./flags/ni.png": 8048,
	"./flags/nl.png": 3472,
	"./flags/no.png": 2745,
	"./flags/np.png": 9423,
	"./flags/nr.png": 3744,
	"./flags/nu.png": 3477,
	"./flags/nz.png": 5799,
	"./flags/om.png": 8063,
	"./flags/pa.png": 68,
	"./flags/pe.png": 7035,
	"./flags/pf.png": 9995,
	"./flags/pg.png": 4082,
	"./flags/ph.png": 5467,
	"./flags/pk.png": 8464,
	"./flags/pl.png": 1343,
	"./flags/pm.png": 4333,
	"./flags/pn.png": 3429,
	"./flags/pr.png": 3694,
	"./flags/ps.png": 942,
	"./flags/pt.png": 2670,
	"./flags/pw.png": 8913,
	"./flags/py.png": 1201,
	"./flags/qa.png": 1916,
	"./flags/re.png": 2311,
	"./flags/ro.png": 4481,
	"./flags/rs.png": 5740,
	"./flags/ru.png": 8544,
	"./flags/rw.png": 5245,
	"./flags/sa.png": 2013,
	"./flags/sb.png": 8240,
	"./flags/sc.png": 2499,
	"./flags/sd.png": 5248,
	"./flags/se.png": 4405,
	"./flags/sg.png": 2557,
	"./flags/sh.png": 8290,
	"./flags/si.png": 5772,
	"./flags/sj.png": 8725,
	"./flags/sk.png": 3044,
	"./flags/sl.png": 1915,
	"./flags/sm.png": 2424,
	"./flags/sn.png": 6084,
	"./flags/so.png": 9298,
	"./flags/sr.png": 7550,
	"./flags/ss.png": 2017,
	"./flags/st.png": 8831,
	"./flags/sv.png": 7974,
	"./flags/sx.png": 9706,
	"./flags/sy.png": 8226,
	"./flags/sz.png": 2021,
	"./flags/tc.png": 5017,
	"./flags/td.png": 4104,
	"./flags/tf.png": 7006,
	"./flags/tg.png": 4863,
	"./flags/th.png": 1307,
	"./flags/tj.png": 8207,
	"./flags/tk.png": 7372,
	"./flags/tl.png": 128,
	"./flags/tm.png": 1322,
	"./flags/tn.png": 7257,
	"./flags/to.png": 2174,
	"./flags/tr.png": 1797,
	"./flags/tt.png": 3265,
	"./flags/tv.png": 9354,
	"./flags/tw.png": 1427,
	"./flags/tz.png": 1659,
	"./flags/ua.png": 2357,
	"./flags/ug.png": 7743,
	"./flags/um.png": 8180,
	"./flags/us.png": 3374,
	"./flags/uy.png": 5176,
	"./flags/uz.png": 902,
	"./flags/va.png": 1640,
	"./flags/vc.png": 1522,
	"./flags/ve.png": 7139,
	"./flags/vg.png": 9662,
	"./flags/vi.png": 8280,
	"./flags/vn.png": 3765,
	"./flags/vu.png": 9794,
	"./flags/wf.png": 127,
	"./flags/ws.png": 9307,
	"./flags/xk.png": 84,
	"./flags/ye.png": 194,
	"./flags/yt.png": 1493,
	"./flags/za.png": 66,
	"./flags/zm.png": 9241,
	"./flags/zw.png": 3702,
	"./giphy (2).gif": 8275,
	"./giphy.gif": 148,
	"./hamburger-menu.png": 7770,
	"./health-insurance.png": 8318,
	"./hidden.png": 3216,
	"./home.png": 6553,
	"./import.png": 6945,
	"./info.png": 9548,
	"./kpi.png": 1318,
	"./left-arrow-2.png": 4341,
	"./left-arrow-sidebar.png": 7297,
	"./logo-3.png": 3407,
	"./logo.jpg": 5096,
	"./logo2.png": 1637,
	"./logout.png": 6645,
	"./mail_2.png": 8274,
	"./my-user.png": 791,
	"./notice.png": 269,
	"./notification-bell.png": 4328,
	"./ola.png": 4614,
	"./organization.png": 7484,
	"./pages-ss.png": 9258,
	"./pencil.png": 8885,
	"./people-2.png": 9450,
	"./people.png": 9833,
	"./phone.png": 9156,
	"./plus-2.png": 9277,
	"./plus.png": 8859,
	"./point.png": 5040,
	"./question_ico.png": 8863,
	"./refresh.png": 9046,
	"./right-arrow-2.png": 3348,
	"./right-arrow-sidebar.png": 4482,
	"./right-arrow.png": 7898,
	"./robot.png": 8649,
	"./save.png": 1113,
	"./search.png": 2305,
	"./services.png": 5769,
	"./settings-2.png": 1813,
	"./settings.png": 8957,
	"./sign.png": 818,
	"./sla-2.png": 8358,
	"./sla.png": 4812,
	"./success.png": 8296,
	"./trend.png": 1220,
	"./uc.png": 2368,
	"./up-arrow.png": 7907,
	"./user-2.png": 6784,
	"./user-3.png": 6343,
	"./user-4.png": 9150,
	"./user.png": 2315,
	"./warning.png": 716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;